const colorScales = {
    white: [
		"#ffffff",
		"#e6e6e6",
		"#cccccc",
		"#b3b3b3",
		"#999999",
		"#808080",
		"#666666",
		"#4d4d4d",
		"#333333",
		"#000000",
	],
	red: [
		"#fcf3f2ff",
		"#fadcd9ff",
		"#fabbb4ff",
		"#fc9086ff",
		"#fa5343ff",
		"#d91f11ff",
		"#a1160aff",
		"#75160cff",
		"#4f150fff",
		"#24120cff",
	],
	orange: [
		"#fcf2ebff",
		"#fcddc7ff",
		"#fcbc97ff",
		"#fc9162ff",
		"#e86427ff",
		"#bf4815ff",
		"#8f3415ff",
		"#632b17ff",
		"#402117ff",
		"#1f1410ff",
	],
	yellow: [
		"#FFFCF5",
		"#FFF1CC",
		"#FFE499",
		"#FFD666",
		"#FFC933",
		"#FFBB00",
		"#CC9600",
		"#997000",
		"#664B00",
		"#332500",
	],
	lime: [
		"#ebf7daff",
		"#d5f0b1ff",
		"#aad971ff",
		"#78bf39ff",
		"#52a31dff",
		"#3c7d0eff",
		"#2e5c0eff",
		"#254211ff",
		"#1c2e10ff",
		"#121a0dff",
	],
	green: [
		"#ebf7edff",
		"#c7ebd1ff",
		"#88dba8ff",
		"#43c478ff",
		"#16a163ff",
		"#077d55ff",
		"#075e45ff",
		"#094536ff",
		"#092e25ff",
		"#081a15ff",
	],
	teal: [
		"#ebf5f4ff",
		"#beebe7ff",
		"#86d9d4ff",
		"#4ebfb9ff",
		"#279c9cff",
		"#167b7dff",
		"#155c5eff",
		"#124241ff",
		"#102e2dff",
		"#0c1a19ff",
	],
	turquoise: [
		"#ebf5f4ff",
		"#c7e8edff",
		"#81d8e5ff",
		"#45bcd1ff",
		"#159ab2ff",
		"#067a91ff",
		"#09596bff",
		"#0c424dff",
		"#102d33ff",
		"#0f181aff",
	],
	aqua: [
		"#ebf3f7ff",
		"#c9e7f5ff",
		"#8bd3f7ff",
		"#48b8f0ff",
		"#1195d6ff",
		"#0073baff",
		"#08548aff",
		"#0e3d66ff",
		"#0c2b45ff",
		"#0b1724ff",
	],
	blue: [
		"#E4EEFF",
		"#AECBFF",
		"#7AA7FF",
		"#477FFF",
		"#144FFF",
		"#002AFF",
		"#001CBE",
		"#00169E",
		"#000A63",
		"#00022E",
	],
	ultramarine: [
		"#EBECFF",
		"#D7D9FF",
		"#B1B2FF",
		"#7F73FE",
		"#643DF8",
		"#5A00F4",
		"#4100B5",
		"#1E005E",
		"#09002B",
		"#120033",
	],
	purple: [
		"#f7f2fcff",
		"#eadcfcff",
		"#dabefaff",
		"#c89afcff",
		"#ac71f0ff",
		"#8f49deff",
		"#6b30abff",
		"#4c277dff",
		"#331f4dff",
		"#1c1229ff",
	],
	pink: [
		"#fcf0f8ff",
		"#f7daedff",
		"#f7b7e2ff",
		"#fa87d4ff",
		"#ed4cb7ff",
		"#cc1d92ff",
		"#961574ff",
		"#6b155aff",
		"#47153fff",
		"#241020ff",
	],
	gray: [
		"#FCFDFE",
		"#F0F2F4",
		"#D2D7DF",
		"#B4BCCB",
		"#8C9DA6",
		"#6F8490",
		"#596A73",
		"#434F56",
		"#2C353A",
		"#030405",
	],
    inkGray: [
        "#F8FBFF",  // paper (가장 밝음)
		"#EFF5FC",  // background (2번째 밝음)
		"#E4E7EA",  // subtle border, disabled elements
		"#D1D6DB",  // subtle backgrounds
		"#B8C0C8",  // placeholder text
		"#9CA6B0",  // secondary text (접근성 확보)
		"#7A8591",  // primary secondary text 
		"#4D6B78",  // strong secondary text
		"#3F4B56",  // near-primary text
		"#1A252F",  // ui.dark.bold (가장 어두움)
    ],
};

const scaleKeys = ["50", "100", "200", "300", "400", "500", "600", "700", "800", "900"];

const createScaleMap = (values) => {
    const map = {};
    values.forEach((value, index) => {
        const key = scaleKeys[index] || String(index);
        map[key] = value;
    });
    return map;
};

const paletteMap = Object.fromEntries(
  Object.entries(colorScales).map(([name, values]) => [name, createScaleMap(values)])
);

const colors = { ...colorScales };

Object.defineProperty(colors, "paletteMap", {
  value: paletteMap,
  enumerable: false,
  writable: false,
});

export default colors;
export { paletteMap };
